import React from 'react'
import TabLinkUI from '../../../widgets/output/TabLinkUI'

const DisbursementsNavUI = ({ context, page }) =>
  <div>
    <div className='g_flex_h g_flex_left g_flex_wrap'>
      <TabLinkUI label='All time' to='/su/disbursements' active={page === 'disbursements'} />
      <TabLinkUI label='Monthly' to='/su/disbursements/monthly' active={page === 'monthly'} />
    </div>
    <div className='g_m_top_50' />
  </div>

export default DisbursementsNavUI